

const categoryTreeSkeletonInit = () => {
    try {
        const count = document.querySelector('.category-grid>ul').childElementCount;
        const width = document.querySelector('.category-tree-categories-title').offsetWidth
        let height
        let rowCount = 1
        if (width < 768) {
            if (count > 2) {
                rowCount = (Math.ceil(count/2))
                height = ((width/2) * rowCount)
            } else {
                height = width/count
            }
        }
        if (width >= 768) {
            if (count > 5) {
                rowCount = (Math.ceil(count/5))
                height = ((width/5) * rowCount)
            } else {
                height = width/count
            }
        }
        const skeleton = document.querySelector('.js-categoryTree-skeleton')
        Array(rowCount).fill(0).forEach(x => {
            const div = document.createElement('div');
            div.classList.add('skeleton-loader');
            div.style.height = (height/rowCount) - 5 + 'px';
            div.style.marginBottom = '5px';
            skeleton.appendChild(div)
        })
    } catch (e) {
        console.log(e)
    }
}

categoryTreeSkeletonInit()